import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

/*BootstrapTable anbd table Related*/

/*Other Components*/
import Periods from "../../../components/common/PeriodsBySport";
import Sports from "../../../components/common/Sports";

/*Loader */
import FadeIn from "react-fade-in";

/*animation*/
import Loader from "../../common/loader/Loader";
/*Inputs*/
/*Styles*/
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import Changes from "../../common/Changes";
import "./ProfileSettings.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  label: {
    fontSize: 12,
    margin: 0,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));
const priceFormatter = (cell, row) => {
  let isSelected = "";
  let isSelected0 = "";
  let isSelected1 = "";
  let isSelected2 = "";
  let isSelected3 = "";
  let isSelected4 = "";
  switch (cell) {
    case 0:
      isSelected0 = "checked";
      break;
    case 1:
      isSelected1 = "checked";
      break;
    case 2:
      isSelected2 = "checked";
      break;
    case 3:
      isSelected3 = "checked";
      break;
    case 4:
      isSelected4 = "checked";
      break;
    default:
      isSelected = "checked";
  }
  return `
    <input type="radio" id="isSelected0" name="age" value="0" ${isSelected0}>
    <label for="isSelected0">Keep Price</label><br>
    <input type="radio" id="isSelected1" name="age" value="1" ${isSelected1}>
    <label for="isSelected1">Credit use line, Cash Adjust win amount</label><br>
    <input type="radio" id="isSelected2" name="age" value="2" ${isSelected2}>
    <label for="isSelected2">Adjust Risk Amount</label><br>
    <input type="radio" id="isSelected3" name="age" value="3" ${isSelected3}>
    <label for="isSelected3">Adjust Win Amount</label><br>
    <input type="radio" id="isSelected4" name="age" value="4" ${isSelected4}>
    <label for="isSelected4">UseLine</label><br>

 `;
};
export default function ProfileSettings(props) {
  const classes = useStyles();
  const [gameRelatedOptions, setGameRelatedOptions] = React.useState();
  const [idSport, setIdSport] = React.useState("CBB");
  const [period, setPeriod] = React.useState("0");
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [isLoading, setIsLoading] = React.useState(true);
  let idProfile = props.Profile.idProfile;

  const requestGameRelated = useCallback(() => {
    const url =
      process.env.REACT_APP_API2_URL +
      "/Game/GameRelatedOptions_GetInfo" +
      "?idProfile=" +
      idProfile +
      "&idSport=" +
      idSport +
      "&idPeriod=" +
      period;
    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    })
      .then((response) => response.data)
      .then((data) => {
        setGameRelatedOptions(data);
      });
  }, [idSport, period, idProfile]);

  useEffect(() => {
    requestGameRelated();
    setIsLoading(false);
  }, [requestGameRelated, setIsLoading]);
  // const [selectedIdGame, setselectedIdGame] = useState();

  function onAfterSaveCell(row, cellName, cellValue) {
    props.UpdateProfile(row);
  }
  function onAfterSaveCellRelated(row, cellName, cellValue) {
    UpdateRelatedGame(row);
  }

  const UpdateRelatedGame = useCallback(
    (row) => {
      let gameRelatedOptionsRequest = {
        IdProfile: idProfile,
        IdSport: idSport,
        IdPeriod: period,
        MLFav_Over: row.mLFav_Over,
        MLFav_Under: row.mLFav_Under,
        MLDog_Over: row.mLDog_Over,
        MLDog_Under: row.mLDog_Under,
        SpreadFav_Over: row.sprFav_Over,
        SpreadFav_Under: row.sprFav_Under,
        SpreadDog_Over: row.sprDog_Over,
        SpreadDog_Under: row.sprDog_Under,
        IdUser: userInfo.userId,
      };
      axios({
        method: "post",
        url: process.env.REACT_APP_API2_URL + "/Game/GameRelatedOptions_Update",
        data: gameRelatedOptionsRequest,
      }).then((response) => {
        if (response.data === "-1") {
          alert("Data Successfully Updated");
        }
        requestGameRelated();
      });
    },
    [requestGameRelated, userInfo]
  );

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
  };

  const cellEditProp = {
    mode: "click",
    blurToSave: true,
    afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };
  const cellEditRelatedGameProp = {
    mode: "click",
    blurToSave: true,
    afterSaveCell: onAfterSaveCellRelated, // a hook for after saving cell
  };

  const setIdSportOnMem = (IdSport) => {
    setIdSport(IdSport);
  };
  const setPeriodOnMem = (period) => {
    setPeriod(period);
  };
  /*Loader*/
  /**/

  const handleGameRelatedChange = (event, key, value) => {
    const options = {
      ...gameRelatedOptions,
      [key]: event ? event.target.value : value,
    };
    UpdateRelatedGame(options);
  };

  const [localProfile, setLocalProfile] = useState(props.Profile);
  const handleUpdate = (event, key, value) => {
    props.Profile[key] = event ? event.target.value : value;
    props.UpdateProfile(props.Profile);
  };
  const handleChange = (event, key, value) => {
    setLocalProfile({
      ...localProfile,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setLocalProfile(props.Profile);
  }, [props.Profile, setLocalProfile]);

  let duplicateBetsParlay = "NONE";
  if (
    localProfile.duplicateBetsCheckParlaysSB &&
    !localProfile.duplicateBetsCheckSameParlay
  ) {
    duplicateBetsParlay = "SB";
  } else if (
    !localProfile.duplicateBetsCheckParlaysSB &&
    localProfile.duplicateBetsCheckSameParlay
  ) {
    duplicateBetsParlay = "SD";
  } else if (
    !localProfile.duplicateBetsCheckParlaysSB &&
    !localProfile.duplicateBetsCheckSameParlay
  ) {
    duplicateBetsParlay = "NONE";
  }

  let duplicateBetsTeasers = "NONE";
  if (
    localProfile.duplicateBetsCheckTeasersSB &&
    !localProfile.duplicateBetsCheckSameTeaser
  ) {
    duplicateBetsTeasers = "SB";
  } else if (
    !localProfile.duplicateBetsCheckTeasersSB &&
    localProfile.duplicateBetsCheckSameTeaser
  ) {
    duplicateBetsTeasers = "SD";
  } else if (
    !localProfile.duplicateBetsCheckTeasersSB &&
    !localProfile.duplicateBetsCheckSameTeaser
  ) {
    duplicateBetsTeasers = "NONE";
  }

  if (!gameRelatedOptions) return <></>;
  return (
    <React.Fragment>
      <div class="main-div">
        {isLoading ? (
          <FadeIn>
            <div class="d-flex justify-content-center align-items-center">
              <Loader height={360} width={360} />
            </div>
          </FadeIn>
        ) : (
          ""
        )}

        <div className="flex flex-col gap-4">
          <div className="grid flex-1 grid-cols-3 gap-4">
            <div className="!gap-0 vertical-options">
              <h3>Pitcher Change Type</h3>
              <FormControl component="fieldset">
                <RadioGroup
                  label
                  value={localProfile.pC_PitcherChangeType}
                  onChange={(event) => {
                    handleChange(event, "pC_PitcherChangeType");
                    handleUpdate(event, "pC_PitcherChangeType");
                  }}
                >
                  <FormControlLabel
                    control={<Radio value={0} size="small" color="primary" />}
                    label="Keep Price"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value={1} size="small" color="primary" />}
                    label="Credit use line, Cash Adjust win amount"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value={2} size="small" color="primary" />}
                    label="Adjust Risk Amount"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value={3} size="small" color="primary" />}
                    label="Adjust Win Amount"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value={4} size="small" color="primary" />}
                    label="Use line"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className="!gap-0 vertical-options">
              <h3>MLB Pitcher Change</h3>
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={localProfile.pC_SkipSide}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "pC_SkipSide",
                        event.target.checked
                      );
                      handleUpdate(
                        undefined,
                        "pC_SkipSide",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Skip Side"
              />
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={localProfile.pC_SkipTotal}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "pC_SkipTotal",
                        event.target.checked
                      );
                      handleUpdate(
                        undefined,
                        "pC_SkipTotal",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Skip Total"
              />
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={localProfile.pC_SkipRunLine}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "pC_SkipRunLine",
                        event.target.checked
                      );
                      handleUpdate(
                        undefined,
                        "pC_SkipRunLine",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Skip Run Line"
              />
            </div>
            <div className="!gap-0 vertical-options">
              <h3>MLB Short Game</h3>
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={localProfile.sG_CancelSide}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "sG_CancelSide",
                        event.target.checked
                      );
                      handleUpdate(
                        undefined,
                        "sG_CancelSide",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Cancel Side"
              />
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={localProfile.sG_CancelTotal}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "sG_CancelTotal",
                        event.target.checked
                      );
                      handleUpdate(
                        undefined,
                        "sG_CancelTotal",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Cancel Total"
              />
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={localProfile.sG_CancelRunLine}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "sG_CancelRunLine",
                        event.target.checked
                      );
                      handleUpdate(
                        undefined,
                        "sG_CancelRunLine",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Cancel Run Line"
              />
            </div>
          </div>
          <div className="grid flex-1 grid-cols-2 gap-4">
            <div className="vertical-options">
              <h3>Related Options By Game</h3>
              <Sports setIdSportOnMem={setIdSportOnMem}></Sports>

              <Periods
                setPeriodOnMem={setPeriodOnMem}
                filterBy={idSport}
              ></Periods>

              {gameRelatedOptions && (
                <>
                  <div className="flex flex-col !gap-0">
                    <FormControlLabel
                      classes={{ label: classes.label }}
                      control={
                        <Checkbox
                          size="small"
                          checked={gameRelatedOptions.mLDog_Over}
                          onChange={(event) => {
                            handleGameRelatedChange(
                              undefined,
                              "mLDog_Over",
                              event.target.checked
                            );
                          }}
                          color="primary"
                        />
                      }
                      label="Dog Money Line / Total Over"
                    />
                    <FormControlLabel
                      classes={{ label: classes.label }}
                      control={
                        <Checkbox
                          size="small"
                          checked={gameRelatedOptions.mLDog_Under}
                          onChange={(event) => {
                            handleGameRelatedChange(
                              undefined,
                              "mLDog_Under",
                              event.target.checked
                            );
                          }}
                          color="primary"
                        />
                      }
                      label="Dog Money Line / Total Under"
                    />
                    <FormControlLabel
                      classes={{ label: classes.label }}
                      control={
                        <Checkbox
                          size="small"
                          checked={gameRelatedOptions.mLFav_Under}
                          onChange={(event) => {
                            handleGameRelatedChange(
                              undefined,
                              "mLFav_Under",
                              event.target.checked
                            );
                          }}
                          color="primary"
                        />
                      }
                      label="Fav Money Line / Total Over"
                    />
                    <FormControlLabel
                      classes={{ label: classes.label }}
                      control={
                        <Checkbox
                          size="small"
                          checked={gameRelatedOptions.mLFav_Over}
                          onChange={(event) => {
                            handleGameRelatedChange(
                              undefined,
                              "mLFav_Over",
                              event.target.checked
                            );
                          }}
                          color="primary"
                        />
                      }
                      label="Fav Money Line / Total Under"
                    />
                  </div>
                  <div className="flex flex-col !gap-0">
                    <FormControlLabel
                      classes={{ label: classes.label }}
                      control={
                        <Checkbox
                          size="small"
                          checked={gameRelatedOptions.sprDog_Over}
                          onChange={(event) => {
                            handleGameRelatedChange(
                              undefined,
                              "sprDog_Over",
                              event.target.checked
                            );
                          }}
                          color="primary"
                        />
                      }
                      label="Dog Spread / Total Over"
                    />
                    <FormControlLabel
                      classes={{ label: classes.label }}
                      control={
                        <Checkbox
                          size="small"
                          checked={gameRelatedOptions.sprDog_Under}
                          onChange={(event) => {
                            handleGameRelatedChange(
                              undefined,
                              "sprDog_Under",
                              event.target.checked
                            );
                          }}
                          color="primary"
                        />
                      }
                      label="Dog Spread / Total Under"
                    />
                    <FormControlLabel
                      classes={{ label: classes.label }}
                      control={
                        <Checkbox
                          size="small"
                          checked={gameRelatedOptions.sprFav_Over}
                          onChange={(event) => {
                            handleGameRelatedChange(
                              undefined,
                              "sprFav_Over",
                              event.target.checked
                            );
                          }}
                          color="primary"
                        />
                      }
                      label="Fav Spread / Total Over"
                    />
                    <FormControlLabel
                      classes={{ label: classes.label }}
                      control={
                        <Checkbox
                          size="small"
                          checked={gameRelatedOptions.sprFav_Under}
                          onChange={(event) => {
                            handleGameRelatedChange(
                              undefined,
                              "sprFav_Under",
                              event.target.checked
                            );
                          }}
                          color="primary"
                        />
                      }
                      label="Fav Spread / Total Under"
                    />
                  </div>
                </>
              )}
              <Changes
                title={`${idSport} GAME Game Related Options`}
                params={{
                  ChangeType: 22,
                  IdSport: idSport,
                  Param1: idProfile,
                  Param2: period,
                  Param3: 0,
                }}
              />
            </div>
            <div className="flex flex-col">
              <h3>Duplicated Bets Options</h3>
              <div className="flex-1 col-span-2 mb-4 vertical-options !gap-0">
                <h3>Check duplicated bets on</h3>
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localProfile.duplicateBetsCheckLineChange}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "duplicateBetsCheckLineChange",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "duplicateBetsCheckLineChange",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Line Changes"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localProfile.duplicateBetsCheckParlays}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "duplicateBetsCheckParlays",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "duplicateBetsCheckParlays",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Parlays"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localProfile.duplicateBetsCheckTeasers}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "duplicateBetsCheckTeasers",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "duplicateBetsCheckTeasers",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Teasers"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localProfile.duplicateBetsCheckReverses}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "duplicateBetsCheckReverses",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "duplicateBetsCheckReverses",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Reverses"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localProfile.duplicateBetsCheckIfbets}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "duplicateBetsCheckIfbets",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "duplicateBetsCheckIfbets",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="If Bets"
                />
              </div>
              <div className="grid flex-1 grid-cols-2 gap-4">
                <div className="col-span-1 vertical-options">
                  <h3>Parlays</h3>
                  <FormControl
                    component="fieldset"
                    disabled={!localProfile.duplicateBetsCheckParlays}
                  >
                    <RadioGroup
                      label
                      className="text-xs"
                      value={duplicateBetsParlay}
                      onChange={(event) => {
                        switch (event.target.value) {
                          case "SB":
                            props.Profile["duplicateBetsCheckParlaysSB"] = true;
                            props.Profile[
                              "duplicateBetsCheckSameParlay"
                            ] = false;
                            setLocalProfile(props.Profile);
                            props.UpdateProfile(props.Profile);
                            break;
                          case "SD":
                            props.Profile[
                              "duplicateBetsCheckParlaysSB"
                            ] = false;
                            props.Profile[
                              "duplicateBetsCheckSameParlay"
                            ] = true;
                            setLocalProfile(props.Profile);
                            props.UpdateProfile(props.Profile);
                            break;
                          default:
                            props.Profile[
                              "duplicateBetsCheckParlaysSB"
                            ] = false;
                            props.Profile[
                              "duplicateBetsCheckSameParlay"
                            ] = false;
                            setLocalProfile(props.Profile);
                            props.UpdateProfile(props.Profile);
                            break;
                        }
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Radio value="SB" size="small" color="primary" />
                        }
                        label="Check with Straight Bets"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        control={
                          <Radio value="SD" size="small" color="primary" />
                        }
                        label="Check with same details"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        control={
                          <Radio value="NONE" size="small" color="primary" />
                        }
                        label="None"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className="col-span-1 vertical-options">
                  <h3>Teasers</h3>

                  <FormControl
                    component="fieldset"
                    disabled={!localProfile.duplicateBetsCheckTeasers}
                  >
                    <RadioGroup
                      label
                      value={duplicateBetsTeasers}
                      onChange={(event) => {
                        switch (event.target.value) {
                          case "SB":
                            props.Profile["duplicateBetsCheckTeasersSB"] = true;
                            props.Profile[
                              "duplicateBetsCheckSameTeaser"
                            ] = false;
                            setLocalProfile(props.Profile);
                            props.UpdateProfile(props.Profile);
                            break;
                          case "SD":
                            props.Profile[
                              "duplicateBetsCheckTeasersSB"
                            ] = false;
                            props.Profile[
                              "duplicateBetsCheckSameTeaser"
                            ] = true;
                            setLocalProfile(props.Profile);
                            props.UpdateProfile(props.Profile);
                            break;
                          default:
                            props.Profile[
                              "duplicateBetsCheckTeasersSB"
                            ] = false;
                            props.Profile[
                              "duplicateBetsCheckSameTeaser"
                            ] = false;
                            setLocalProfile(props.Profile);
                            props.UpdateProfile(props.Profile);
                            break;
                        }
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Radio value="SB" size="small" color="primary" />
                        }
                        label="Check with Straight Bets"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        control={
                          <Radio value="SD" size="small" color="primary" />
                        }
                        label="Check with same details"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        control={
                          <Radio value="NONE" size="small" color="primary" />
                        }
                        label="None"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className="col-span-2 vertical-options">
                  <h3>Reverses</h3>

                  <FormControlLabel
                    disabled={!localProfile.duplicateBetsCheckReverses}
                    classes={{ label: classes.label }}
                    control={
                      <Checkbox
                        size="small"
                        checked={localProfile.duplicateBetsCheckIfSBRev}
                        onChange={(event) => {
                          handleChange(
                            undefined,
                            "duplicateBetsCheckIfSBRev",
                            event.target.checked
                          );
                          handleUpdate(
                            undefined,
                            "duplicateBetsCheckIfSBRev",
                            event.target.checked
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="Check If Bets & Reverses with Straight Bets"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="grid flex-1 grid-cols-2 gap-4">
            <div className="col-span-1 vertical-options">
              <h3>Free Plays</h3>
              <div className="grid flex-1 grid-cols-2 gap-4">
                <div className="flex flex-col h-full col-span-1 gap-4">
                  <TextField
                    size="small"
                    type="number"
                    label="Max Payout"
                    value={localProfile.fPMaxPayout}
                    onChange={(event) => handleChange(event, "fPMaxPayout")}
                    onBlur={(event) => handleUpdate(event, "fPMaxPayout")}
                    variant="outlined"
                  />
                  <TextField
                    size="small"
                    type="number"
                    label="Odds limit"
                    value={localProfile.fPOddsLimit}
                    onChange={(event) => handleChange(event, "fPOddsLimit")}
                    onBlur={(event) => handleUpdate(event, "fPOddsLimit")}
                    variant="outlined"
                  />
                  <TextField
                    size="small"
                    type="number"
                    label="Max # of Teams"
                    value={localProfile.fPMaxTeams}
                    onChange={(event) => handleChange(event, "fPMaxTeams")}
                    onBlur={(event) => handleUpdate(event, "fPMaxTeams")}
                    variant="outlined"
                  />
                  <TextField
                    size="small"
                    type="number"
                    label="Max # of Favs"
                    value={localProfile.fPMaxFav}
                    onChange={(event) => handleChange(event, "fPMaxFav")}
                    onBlur={(event) => handleUpdate(event, "fPMaxFav")}
                    variant="outlined"
                  />
                </div>
                <div className="flex flex-col h-full col-span-1 gap-0">
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    control={
                      <Checkbox
                        size="small"
                        checked={localProfile.fPAllowBothSides}
                        onChange={(event) => {
                          handleChange(
                            undefined,
                            "fPAllowBothSides",
                            event.target.checked
                          );
                          handleUpdate(
                            undefined,
                            "fPAllowBothSides",
                            event.target.checked
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="Allow Both Sides"
                  />
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    control={
                      <Checkbox
                        size="small"
                        checked={localProfile.fPAllowDuplicatedBets}
                        onChange={(event) => {
                          handleChange(
                            undefined,
                            "fPAllowDuplicatedBets",
                            event.target.checked
                          );
                          handleUpdate(
                            undefined,
                            "fPAllowDuplicatedBets",
                            event.target.checked
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="Allow Duplicate Bets"
                  />
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    control={
                      <Checkbox
                        size="small"
                        checked={localProfile.fPCheckOfficeFilters}
                        onChange={(event) => {
                          handleChange(
                            undefined,
                            "fPCheckOfficeFilters",
                            event.target.checked
                          );
                          handleUpdate(
                            undefined,
                            "fPCheckOfficeFilters",
                            event.target.checked
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="Check Office Filters"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col col-span-1 gap-4">
              <div className="vertical-options">
                <h3>Card Limits</h3>
                <TextField
                  size="small"
                  type="number"
                  label="Max Wager"
                  value={localProfile.cLMaxWager}
                  onChange={(event) => handleChange(event, "cLMaxWager")}
                  onBlur={(event) => handleUpdate(event, "cLMaxWager")}
                  variant="outlined"
                />
              </div>
              <div className="vertical-options">
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localProfile.soc_Hookups}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "soc_Hookups",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "soc_Hookups",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Allow Hookups in Related Soccer Games"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localProfile.rev_AllowOpen}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "rev_AllowOpen",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "rev_AllowOpen",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Allow Open Sports in Reverses"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
